export default __webpack_public_path__ + "473a58f62a259656e445a6b4114e6dce.jpg";